import { render, staticRenderFns } from "./Post3500-H.vue?vue&type=template&id=2481c50f"
import script from "./Post3500-H.vue?vue&type=script&lang=js"
export * from "./Post3500-H.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports